import React, {useEffect} from 'react';
import './App.css';
import {BrowserRouter as Router, Route, Routes, useLocation} from 'react-router-dom';
import SlotPage from './Pages/SlotPage';
import {IndexPage} from './Pages/IndexPage';
import Layout from './Layout/Main.Layout';
import ServicesPage from './Pages/ServicesPage';
import AboutPage from './Pages/AboutPage';
import ContactsPage from './Pages/ContactsPage';
import SlotsPage from './Pages/SlotsPage';
import NotFoundPage from './Pages/NotFoundPage';
import TermsConditionsPage from './Pages/Terms&ConditionsPage';
import {ShowreelPage} from './Pages/Showreel';
import {BaseSEO} from './Pages/BaseSEO';

function ScrollToTop() {
    const {pathname} = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null; // Этот компонент ничего не рендерит
}

function App() {
    // return <Preloader/>
    return (
        <>
            <BaseSEO/>
            <Router>
                <ScrollToTop/>
                <Routes>
                    <Route element={<Layout/>}>
                        <Route path="/" element={<IndexPage/>}/>
                        <Route path="services" element={<ServicesPage/>}/>
                        <Route path="about" element={<AboutPage/>}/>
                        <Route path="contact" element={<ContactsPage/>}/>
                        <Route path="showreel" element={<ShowreelPage/>}/>


                        <Route path="/slots" element={<SlotsPage/>}/>
                        <Route path="/slot/:id" element={<SlotPage/>}/>
                        <Route path="/terms-condition" element={<TermsConditionsPage/>}/>
                        {/* Добавляем маршрут для 404 */}
                        <Route path="*" element={<NotFoundPage/>}/>
                    </Route>
                </Routes>
            </Router>
        </>
    )
}

export default App;

